import { Button } from '@mui/material';
import { useOpenVideoManagerModal } from 'pages/VideoManager/hooks/useOpenVideoManagerModal';
import { FunctionComponent } from 'react';
import { VideoGenerationNotificationItem } from './types';

interface ViewGeneratedVideoButtonProps {
  item: VideoGenerationNotificationItem;
  /** Already translated: this button renders inside a toast, above `LocalizedIntlProvider`. */
  label: string;
  onClick: () => void;
}

/** Opens the generated video in the Video manager library, keeping the current page behind the modal. */
export const ViewGeneratedVideoButton: FunctionComponent<ViewGeneratedVideoButtonProps> = ({
  item,
  label,
  onClick,
}) => {
  const openVideoManager = useOpenVideoManagerModal();

  const handleClick = () => {
    onClick();
    openVideoManager('library', item.videoFileId ?? undefined, item.advertiserPrettyId);
  };

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={handleClick}
      data-testid={`video-notification-view-video-${item.id}`}
    >
      {label}
    </Button>
  );
};
